<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="评估记录" :icon="null" title="订单管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
                <el-form :model="search" label-width="80px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="userPhone">
                                <el-input v-model="search.userPhone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车架号:" prop="vin">
                                <el-input v-model="search.vin" placeholder="请输入车架号" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="分析模型:" prop="type">
                                <el-select v-model="search.type" class="m-2" clearable placeholder="请选择分析模型"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options2" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="评估等级:" prop="evaluationGrade">
                                <el-select v-model="search.evaluationGrade" clearable class="m-2" placeholder="请选择评估等级"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="评估时间:" prop="daterange">
                                <el-date-picker v-model="search.daterange" type="datetimerange" range-separator="-"
                                    start-placeholder="评估开始时间" end-placeholder="评估结束时间" format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss" date-format="YYYY-MM-DD" time-format="HH:mm:ss"
                                    style="width: 100%" @change="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="评估订单:" prop="orderId">
                                <el-input v-model="search.orderId" placeholder="请输入评估订单号" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 345px)" row-key="id"
                v-loading="state.tableLoading" @cell-click="handleCellClick">
                <el-table-column prop="type" label="分析模型" min-width="100px">
                    <template #default="scope">
                        <span>{{ formatAnalysisModel(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userPhone" label="手机号码" min-width="120px" />
                <el-table-column prop="vin" label="车架号" min-width="180px">
                    <template #default="scope">
                        <el-link type="primary">{{ scope.row.vin }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluationGrade" label="评估等级" min-width="100px" />
                <el-table-column prop="createTime" label="评估时间" min-width="180px" />
                <el-table-column prop="outerOrderId" label="外部订单ID" min-width="220px" />
                <el-table-column prop="orderId" label="评估订单" min-width="200px" />
                <el-table-column label="报告地址" min-width="260px" show-overflow-tooltip>
                    <template #default="scope">
                        <div v-if="getReportUrlText(scope.row)" class="report-url-cell">
                            <el-link type="primary" :href="getReportUrlText(scope.row)" target="_blank" @click.stop>
                                {{ getReportUrlText(scope.row) }}
                            </el-link>
                            <el-button type="primary" link @click.stop="copyReportUrl(scope.row)">复制</el-button>
                        </div>
                        <span v-else class="empty-text">--</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120px">
                    <template #default="scope">
                        <el-button
                            v-if="!scope.row.reportImageUrl && scope.row.reportUrl && scope.row.type !== '车型识别'"
                            type="primary" link @click="handleGenerateImage(scope.row)">生成图片</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <!-- 链接报告 -->
    <el-dialog v-model="state.dialogVisible" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content">
            <iframe :src="state.reportUrl" style="width: 100%;height: 100%;" frameborder="0"></iframe>
        </div>
    </el-dialog>
    <!-- 图片报告 -->
    <el-dialog v-model="state.imageDialogVisible" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content" style="overflow: auto;">
            <el-image style="width: 100%;" :src="state.reportImageUrl" fit="contain" />
        </div>
    </el-dialog>
    <!-- 车型识别报告 -->
    <el-dialog v-model="state.carTypeDialogVisible" class="car-type" title="报告预览" width="450" destroy-on-close>
        <div class="dialog-content" style="overflow: auto;">
            <el-descriptions :column="1" border>
                <el-descriptions-item label="品牌名称">{{ state.carTypeInfo?.amBrandName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车系名称">{{ state.carTypeInfo?.amSeriesName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车型名称">{{ state.carTypeInfo?.amVehicleName || '--' }}</el-descriptions-item>
                <el-descriptions-item label="国产/进口">{{ state.carTypeInfo?.importFlag || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车型分类">{{ state.carTypeInfo?.vehCateTwoNames || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="上市时间">{{ state.carTypeInfo?.uploadDate || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车身颜色(漆色号)">{{ state.carTypeInfo?.vehicleColor || '--'
                }}</el-descriptions-item>

                <el-descriptions-item label="发动机">{{ state.carTypeInfo?.engineModel || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排量(L)">{{ state.carTypeInfo?.displacement || '--' }}</el-descriptions-item>
                <el-descriptions-item label="机油加注量">{{ state.carTypeInfo?.engineDesc || '--' }}</el-descriptions-item>
                <el-descriptions-item label="燃油动力">{{ state.carTypeInfo?.powerType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="功率">{{ state.carTypeInfo?.power || '--' }}</el-descriptions-item>
                <el-descriptions-item label="燃油标号">{{ state.carTypeInfo?.roz || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排放标准">{{ state.carTypeInfo?.effluentStandard || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="发动机气门数(个)">{{ state.carTypeInfo?.valveNum || '--' }}</el-descriptions-item>
                <el-descriptions-item label="气缸排列形式">{{ state.carTypeInfo?.arrayType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="排放标准">{{ state.carTypeInfo?.effluentStandard || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="驱动形式">{{ state.carTypeInfo?.drivenType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="变速器类型">{{ state.carTypeInfo?.gearboxType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="变速器档数(个)">{{ state.carTypeInfo?.gearNum || '--' }}</el-descriptions-item>

                <el-descriptions-item label="座位数">{{ state.carTypeInfo?.seats || '--' }}</el-descriptions-item>
                <el-descriptions-item label="车身结构">{{ state.carTypeInfo?.bodyType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="进气形式">{{ state.carTypeInfo?.airIntakeType || '--' }}</el-descriptions-item>
                <el-descriptions-item label="前轮距(mm)">{{ state.carTypeInfo?.trackFront || '--' }}</el-descriptions-item>
                <el-descriptions-item label="后轮距(mm)">{{ state.carTypeInfo?.trackRear || '--' }}</el-descriptions-item>
                <el-descriptions-item label="轴距(mm)">{{ state.carTypeInfo?.wheelBase || '--' }}</el-descriptions-item>
                <el-descriptions-item label="前轮胎规格">{{ state.carTypeInfo?.frontTyreSize || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="后轮胎规格">{{ state.carTypeInfo?.rearTyreSize || '--' }}</el-descriptions-item>
                <el-descriptions-item label="外形尺寸/长*宽*高(mm)">{{ state.carTypeInfo?.vehicleSize || '--'
                }}</el-descriptions-item>
                <el-descriptions-item label="车重(kg)">{{ state.carTypeInfo?.fullWeight || '--' }}</el-descriptions-item>
            </el-descriptions>
        </div>
    </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { ElMessage } from 'element-plus'
import { getAssessListFun, getAccidentFun, generateAssessImageFun } from "@/api/consumption"
import { getDictOptionsFun } from "@/api/product"
import { cloneDeep } from 'lodash-es';

const search = reactive({
    userId: "",
    userPhone: "",
    vin: "",
    evaluationGrade: '',
    orderId: '',
    type: '',
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "字段完整", value: '字段完整' },
        { label: "字段不完整", value: '字段不完整' },
    ],
    options2: [
        { label: "出险-车信盟", value: "出险-CXM" },
        { label: "出险-诚浩", value: "出险-CHENGHAO" },
        { label: "出险-三才", value: "出险-SANCAI" },
        { label: "出险-简版底档", value: "出险-SANCAI_BRIEF" },
        { label: "出险-柠檬查", value: "出险-XYL" },
        { label: "出险-车况Plus", value: "出险-PLUS" },
        { label: "出险-车信盟非车损", value: "出险-CXM_NON_DAMAGE" },
        { label: "维保-精友", value: "维保-JINGYOU" },
        { label: "维保-文竹", value: "维保-WENZHU" },
        { label: "车云检", value: "车云检" },
        { label: "车型识别", value: "车型识别" },
        { label: "云端查表", value: "云端查表" },
    ],    dialogVisible: false,
    imageDialogVisible: false,
    reportUrl: '',
    reportImageUrl: '',
    carTypeDialogVisible: false,
    carTypeInfo: {},
})
const tableData = ref([]);
const THIRD_PARTY_VENDOR = "THIRD_PARTY_VENDOR";
const ACCIDENT_VENDOR_CODES = ["CXM", "CHENGHAO", "SANCAI", "SANCAI_BRIEF", "XYL", "PLUS", "CXM_NON_DAMAGE"];
const MAINTENANCE_VENDOR_CODES = ["JINGYOU", "WENZHU"];

const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
const loadAnalysisOptions = () => {
    getDictOptionsFun(THIRD_PARTY_VENDOR).then((res) => {
        const dictOptions = res.data || [];
        const vendorOptions = dictOptions.filter((item) => ACCIDENT_VENDOR_CODES.includes(item.value));
        const maintenanceOptions = dictOptions.filter((item) => MAINTENANCE_VENDOR_CODES.includes(item.value));
        const accidentOptions = vendorOptions.map((item) => ({ label: `\u51fa\u9669-${item.label}`, value: `\u51fa\u9669-${item.value}` }));
        if (!vendorOptions.some((item) => item.value === "SANCAI_BRIEF")) {
            accidentOptions.push({ label: "\u51fa\u9669-\u7b80\u7248\u5e95\u6863", value: "\u51fa\u9669-SANCAI_BRIEF" });
        }
        state.options2 = [
            ...accidentOptions,
            ...maintenanceOptions.map((item) => ({ label: `\u7ef4\u4fdd-${item.label}`, value: `\u7ef4\u4fdd-${item.value}` })),
            { label: "\u8f66\u4e91\u68c0", value: "\u8f66\u4e91\u68c0" },
            { label: "\u8f66\u578b\u8bc6\u522b", value: "\u8f66\u578b\u8bc6\u522b" },
            { label: "\u4e91\u7aef\u67e5\u8868", value: "\u4e91\u7aef\u67e5\u8868" },
        ];
    });
}
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userId = '';
        search.userPhone = '';
        search.vin = '';
        search.evaluationGrade = '';
        search.orderId = '';
        search.type = '';
        search.daterange = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    const searchValue = cloneDeep(search);
    for (let key in searchValue) {
        if (searchValue[key]) {
            if (key == 'daterange') {
                params.formValue['startTime'] = searchValue[key][0];
                params.formValue['endTime'] = searchValue[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else if (key == 'type') {
                if (searchValue.type.includes('出险') || searchValue.type.includes('维保')) {
                    const productType = searchValue.type.includes('出险') ? '出险' : '维保';
                    params.formValue[key] = productType;
                    const thirdPartyName = searchValue.type.replace(new RegExp(`^${productType}-?`), '');
                    if (thirdPartyName) {
                        params.formValue['thirdPartyName'] = thirdPartyName;
                    }
                    params.keys.push(key);
                    params.keys.push('thirdPartyName');
                } else {
                    params.keys.push(key);
                    params.formValue[key] = searchValue[key];
                }
            } else {
                params.keys.push(key);
                params.formValue[key] = searchValue[key];
            }
        }
    }
    getAssessListFun(params).then((res) => {
        const data = res.data.records;
        tableData.value = data.map((item) => {
            if (item?.type == '车型识别' && item?.reportUrl) {
                item.reportUrl = JSON.parse(item.reportUrl);
            }
            return item;
        });
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 单元格点击事件
const handleCellClick = (row, column, event, cell) => {
    if (column.property == 'vin') {
        // 点击车架号
        if (row.reportUrl) {
            if (row?.thirdPartyName == 'CXM') {
                if (row?.reportImageUrl) {
                    state.reportImageUrl = row.reportImageUrl;
                    state.imageDialogVisible = true;
                } else {
                    // 车信盟需要重新获取连接报告
                    state.fullLoading = true;
                    getAccidentFun(row).then((res) => {
                        if (res?.data?.orderInfo?.reportUrl) {
                            state.reportUrl = decodeURIComponent(res.data.orderInfo.reportUrl);
                            state.dialogVisible = true;
                        }
                    }).finally(() => {
                        state.fullLoading = false;
                    })
                }
            } else if (row?.type == '车型识别') {
                state.carTypeInfo = row.reportUrl[0];
                state.carTypeDialogVisible = true;
            } else {
                state.reportUrl = decodeURIComponent(row.reportUrl);
                state.dialogVisible = true;
            }
        } else {
            ElMessage.warning("未查询到报告！")
        }
    }
}
const safeDecodeUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return '';
    }
    try {
        return decodeURIComponent(url);
    } catch (e) {
        return url;
    }
}
const getReportUrlText = (row) => {
    if (!row || !row.reportUrl || typeof row.reportUrl !== 'string') {
        return '';
    }
    return safeDecodeUrl(row.reportUrl);
}
const copyText = async (text) => {
    if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}
const copyReportUrl = async (row) => {
    const url = getReportUrlText(row);
    if (!url) {
        ElMessage.warning('暂无报告地址');
        return;
    }
    try {
        await copyText(url);
        ElMessage.success('报告地址已复制');
    } catch (e) {
        ElMessage.error('复制失败，请手动复制');
    }
}
const handleGenerateImage = (row) => {
    state.fullLoading = true;
    generateAssessImageFun(row.id).then((res) => {
        ElMessage.success(res?.msg || '生成图片成功');
        intTableData();
    }).catch((err) => {
        ElMessage.error(err?.msg || err?.message || '生成图片失败');
    }).finally(() => {
        state.fullLoading = false;
    });
}
const formatAnalysisModel = (row) => {
    if (!row) {
        return "--";
    }
    const type = row.type || "--";
    const rawThirdPartyName = row.thirdPartyDisplayName || row.thirdPartyName || "";
    const thirdPartyName = rawThirdPartyName === "SANCAI_BRIEF" ? "简版底档" : rawThirdPartyName;
    return thirdPartyName ? `${type}-${thirdPartyName}` : type;
}
onMounted(() => {
    loadAnalysisOptions();
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.report-url-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.report-url-cell .el-link {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.empty-text {
    color: #9ca3af;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}
</style>
